const langCN = {
    "GAS_FEES":"星云网络Gas费用",
    "TX_WARNING":"警告！请稍等,提交交易需要等候一定时间。",
    "COLLECT":"收集",
    "COLLECT_DESCRIPTION":"收集你的卡牌！每张卡牌都是随机生成的,并且包含一个唯一的ID,每张卡牌都对应着不同的属性。",
    "BATTLE_HEADER":"战斗",
    "TRADE":"买卖",
    "GET_COLLECTIBLES":"收集你的卡牌！",
    "PLEASE_WAIT":"请稍候......",
    "VS":"VS",
    "BATTLE_NOW":"立即战斗",
    "CREATE_AUCTION":"创建拍卖",
    "TRADE_DESCRIPTION":"您可以买卖您的卡牌！如果您的卡牌评分很高或者很独特,可以创建一个拍卖,来吸引潜在买家。",
    "BATTLE_DESCRIPTION":"战斗并升级您的卡牌！每获得一次胜利,你都会赢得对方的卡牌并且卡牌的等级上升,但是要注意,战斗失败就会失去您的卡牌！较高等级的卡牌更强力,更有可能获胜。",
    "BANNER_HEADER":"收集,战斗和买卖",
    // "BRAND_HEADER":"卡牌大战",
    "BRAND_HEADER":"BATTLE BLOCKS",
    "BRAND_SUBHEADER":"准备战斗！所有战斗都会被记录在区块链上",
    "LOADING":"加载...",
    "CARDS_CREATED":"卡牌创建完成",
    "PENDING_TRANSACTION":"待处理交易",
    "SAVE":"保存",
    "USER_LOADING":"用户正在加载...",
    "CARDS_LOADING":"卡牌正在加载...",
    "BATTLE_CARDS":"战斗卡牌",
    "WINS":"胜利",
    "LOSSES":"损失",
    "CARD_ONLY":"卡牌",
    "LEVEL":"等级",
    "TOTAL":"总计",
    "NO_CARDS":"您没有任何卡牌",
    "INSTALL_EXTENSION":"<strong>您好！</ strong>请登录并安装插件<a href='https://github.com/ChengOrangeJu/WebExtensionWallet' target='_blank'> Nebulas Web Extension Wallet </ a >来使用卡牌大战服务。",
    "NEBULAS_ERROR":"<strong>警告！</ strong>从星云区块链加载数据时出现1个或更多错误,您可能需要重新加载。",
    "ERROR_MESSAGE":"错误消息",
    "ACCOUNT":"帐户",
    "CREATED_ON":"创建时间",
    "NEW":"新",
    "NOTHING_TO_SEE":"没什么可看的......",
    "COMPLETE":"完成",
    "CREATE":"创建",
    "CLOSE":"关闭",
    "PRICE_IN_NAS":"NAS价格",
    "NO_CARDS":"无卡可用",
    "NAME":"名称",
    "SCORE":"得分",
    "LEVEL":"等级",
    "BET":"赌注",
    "SUBMIT":"提交",

    //About Page
    "ABOUT_HEADER":"关于卡牌大战",
    "ABOUT":"BattleBlocks®是一款在<a href='#'> Nebulas </a>区块链上创建的数字资产卡牌游戏,所有卡牌数据均通过区块链技术进行存储和保护,使您可以轻松安全地购买,交易和比赛。",
    "TOKENS_HEADER":"战斗代币",
    "TOKENS":"每次获胜都可获得5个战斗代币,使用代币来升级您的卡牌和购买其他很酷的东西（开发中）。战斗代币可以兑换成对等的NRC-20代币,转换日期将被公布。",
    "GEN_0_HEADER":"第0代卡牌",
    "GEN_0":"每一代产品的供应量都很有限,并且比后一代产品具有更强的属性,第0代产品的上限为5,000张卡牌,并且将获得独特的能力和技能,在战斗中更加占据优势。",
    "GEN_X_HEADER":"第X代卡牌",
    "GEN_X":"第X代卡牌只适用于顶级的选手,可以通过排行榜页面查看,并可以查看他们是否决定拍卖。这些卡牌具有其他卡牌都没有的新技能。",
    "FEES_HEADER":"卡牌大战的费用",
    "FEES_1":"除了手续费没有其他任何费用。",
    "FEES_2":"拍卖会根据限量版卡或用户销售价格收费。",
    "SUBJECT_TO_CHANGE":"*价格可能会有所变化。",

    //Footer
    "FOOTER":{
      "MISSION":"使命",
      "MISSION_TEXT":"重新定义和创新基于区块链的游戏,提高游戏质量,艺术性,娱乐性和可玩性。",
      "EMAIL_TEXT":"通过电子邮件查询",
      "USEFUL_LINKS":"相关链接",
      "RULES":"规则",
      "ABOUT":"关于",
      "BATTLES":"战斗",
      "AUCTIONS":"拍卖",
      "LEADERBOARDS":"排行榜",
      "TERMS_OF_USE":"使用条款",
      "SOCIAL":"社交",
      "CONTRACT":"合同",
    },

    //Auction
    "AUCTION":{
      "CREATE":"创建拍卖",
      "LOADING":"拍卖正在加载...",
      "NONE":"无拍卖",
      "SOLD":"已售出",
      "PRICE":"价格",
      "CREATED_ON":"创建时间",
      "BUY": "购买",
      "ALERT_TEXT":"选择您想拍卖的卡牌",
      "ALERT_SUBTEXT":"创建拍卖除了星云链手续费之外,不收取任何额外费用。",
      "VIEWER":"拍卖浏览器"
    },

    //Battle
    "BATTLE":{
        "CREATE":"发起战斗",
        "FILTER":"搜索战斗",
        "MY_BTLS":"我的战斗",
        "ALL_BTLS":"所有战斗",
        "OPEN_BTLS":"打开战斗",
        "COMP_BTLS":"完成战斗",
        "ALL_SCORES":"所有分数",
        "LOADING":"正在加载......",
        "NO_BTLS":"无战斗",
        "TEAM_SCORE":"战斗得分",
        "NOT_COMPLETE":"这场战斗没有完成。",
        "BATTLE_NOW":"立即战斗",
        "SEE_RESULTS":"查看结果",
        "CHALLENGER_WON":"挑战者赢得了这场战斗。",
        "YOU_CHALLENGER_WON":"你挑战并赢得了这场战斗。",
        "OWNER_WON":"擂主赢得了这场战斗。",
        "YOU_OWNER_WON":"你发起并赢得了这场战斗。",
        "COMPLETE":"这场战斗尚未完成。",
        "CANCELLED":"这场战斗被取消了。",
        "COMMENCE":"开始",
        "CANNOT_EXCEED":"你的分数不能超过擂主分数超过50分。",
        "YOUR_SCORE":"你的分数",
        "OWNER_SCORE":"擂主评分",
        "CREATE_ALERT_TEXT":"选择你最好的3张牌,加上1张赌注牌！",
        "CREATE_ALERT_SUBTEXT":"发起一场战斗,除了星云链手续费之外,不收取任何额外费用。",
        "COMMENCE_ALERT_TEXT":"选择你最好的3张牌,加上1张赌注牌来开始战斗！",
        "COMMENCE_ALERT_SUBTEXT":"战斗除了星云链手续费之外,不收取任何额外费用",
        "COMMENCE_BTL":"开始战斗",
        "OWNER":"所有者",
        "OPPONENT":"对手",
        "ONE" : "一",
        "TWO":"二",
        "THREE":"三",
        "BATTLE":"战斗",
        "WON":"赢"
    },

    //Rules
    "RULES":{
        "CARD_SCORES":"卡牌分数",
        "SCORE_DETAILS":"每张卡片由<strong>能力数值 </ strong>,<strong> 能力类别</ strong>和<strong> 能力属性 </ strong>组成。卡牌分数:所有的 <strong> 能力数值 </ strong>加在一起,每个等级+5。战斗规则的得分计算有些不同,在下面进行描述。",
        "POWER_STATS":"基本能量数值",
        "SP":"速度",
        "ST":"力量",
        "DF":"防御",
        "SA":"耐力",
        "POWER_MODIFIERS":"能力类别",
        "TYPE":"类型 - 治疗者,神秘者,夜光,战士,元素,魔法师。",
        "LEVEL":"等级 - 每次战斗胜利增加1",
        "POWER_ATTRS":"能力属性",
        "IN_DEV":"正在开发......",
        "BATTLE_RULES":"战斗规则",
        "RULES_DESC":"战斗分两步进行:首先,用户必须先发起一场战斗,然后等待对手；其次,对手必须选择从现有的发起战斗开始战斗,目前所有的战斗都是3对战3,有1张赌注卡,每个用户必须选择3张卡和1张赌注卡,他们在失败后会将赌注卡牌输给你,如果他们赢了,他们将获得他们对手的赌注卡,每场战斗包括3比1和1战斗,其中战斗得分按照你的牌的顺序进行编制,例如:你的第一张选择的牌,将与你的对手首先选择的牌作战,你的第二张牌与对手的第二张牌等。胜场最多的人获胜,如三局全胜.胜利者将升级新卡牌和他们自己的赌注卡,另外,用户将获得5个战斗代币。",
        "BATTLE_SCORES":"战斗分数",
        "AP":"AP:攻击点 - 力量x速度",
        "DP":"DP:伤害点 -攻击点/对手的防御",
        "BT":"BT:战斗时间 - 对手的耐力/伤害点",
        "SCORE_MOD":"分数修改",
        "MOD_LEVEL":"等级:总得分加上每个等级+5",
        "HEALER":"类型:治疗者= +5耐力",
        "WARRIOR":"类型:战士= +5防御",
        "MYSTIC":"类型:神秘= +5速度",
        "MAGICIAN":"类型:魔术师= +5速度",
        "LUMINOUS":"类型:夜光= +5强度",
        "LUMINOUS":"类型:元素= +5力量",
        "BTL_OUTCOME":"战斗结果",
        "BTL_OUTCOME_DESC":"较低的BT（战斗时间）获胜（一张卡击败另一张卡需要多少次攻击）",
        "AUCTION_RULES":"拍卖规则",
        "AUCTION_RULES_DESC":"您可以出售和购买任意数量的贺卡,拍卖中的卡片将被锁定,直到它被出售。如果在卡片出售之前拍卖到期,所有者必须在它可能被拍卖或再战斗之前解锁卡片。"
    },

    //Terms
    "TERMS":{
        "TOU":"使用条款",
        "TOU_DESC":"通过使用我们的服务,您同意您对任何收益或损失承担全部责任,并且您已决定自愿并根据此明确协议与本产品进行互动。您同意Battle Blocks®为实验性区块链产品,它受各国的不同的具体法律法规监管,并且您同意遵守您必须遵守法律。区块链技术的实验性和推测性本质使得不可能保证未来的利润或稳定性,因此您同意通过与这种技术进行交互你可以承受失去任何货币价值的投资。您承认本产品仍在开发中,具体的代码和功能部分可能会发生变化。",
        "OWNERSHIP":"所有权",
        "OWNERSHIP_DESC":"你是你创建的数据的所有者,并且已经存储在你的账户中,所有的Battle Block®都作为数据存储在星云区块链中,数据映射到图像上,尽管你拥有这些卡片,您并不拥有定义影像使用或不使用规则的权利,您的所有权由特定卡片以及该卡内置的优势,弱点和经验来定义,Battle Blocks®拥有并保持艺术,图像,并可以改变或改变他们未来的方向。",
        "PROMISE":"对你的承诺",
        "PROMISE_DESC":"我们对您的承诺是尽最大努力创造出最高品质的产品,并与您保持持续的对话,讨论哪些是有效的,哪些是无效的。我们将参与对技术的探索,并发挥所有的Battle Blocks®用户的利益我们期待着与您共同成长并开发出您喜爱的超棒产品欢迎您随时与我们联系并提出任何问题或想法游戏: ）"
    },

    //Leaderboard
    "LEADERBOARD":{
        "FIRST":"第一名奖",
        "SECOND":"第二名奖",
        "THIRD":"第三名奖",
        "SHOWING":"显示20",
        "USERS":"用户",
        "RULES":"<strong>规则:</ strong>不要用虚拟账户与自己争取胜利,如果被抓住,你将被取消资格。",
        "NO_LEADERS":"无排名",
        "LOADING":"排名正在加载...",
        "RANK":"排名",
        "WINS":"胜利",
        "LOSSES":"损失",
        "WIN_PERCENT":"Win％",
        "USER":"用户"
    },

    //Card
    "CARD":{
        "VIEWER":"卡片查看器",
        "LEVEL_UP":"升级",
        "TRANSFER":"转让",
        "LEVEL_DESC":"升级1次需要5个代币",
        "TOKENS":"战斗代币"
    }

};

export default langCN;


// WEBPACK FOOTER //
// ./src/util/translations/lang_cn.js